const messages = {
  title: "Маркетингови съгласия",
  required: "Задължително",
  answered: "✓ Отговорено",
  read: "Прочетено",
  notRead: "Непрочетено",
  alreadyAnswered: "Вече отговорено",
  requiredQuestionsMustBeAccepted:
    "Трябва да приемете още {count} задължителни въпроса",
  pleaseAnswerQuestions: "Моля, отговорете на следните въпроси:",
  iAccept: "Приемам",
  scrollToUnlock: "Превъртете до края, за да отключите",
  fieldRequired: "Това поле е задължително",
  scrollToContinue: "↓ Превъртете до края, за да продължите",
  saving: "Запазване...",
  saveConsents: "Запазване на съгласията",
  allRequiredAccepted: "✓ Всички задължителни въпроси са приети",
  requiredConsentsCompleted:
    "{completed}/{total} задължителни съгласия попълнени",
  selectConsentToView:
    "Изберете съгласие от списъка, за да видите съдържанието",
  readAllContentFirst: "Първо прочетете цялото съдържание: {names}",
  acceptAllRequiredIn:
    "Приемете всички задължителни въпроси в: {names}",
  acceptAllBeforeSaving:
    "Преди запазване приемете всички задължителни въпроси.",
  failedToSave: "Съгласията не можаха да бъдат запазени. Опитайте отново.",
  errorSaving:
    "Възникна грешка при запазване на съгласията. Опитайте отново.",
  failedToLoad: "Съгласията не можаха да бъдат заредени. Обновете страницата.",
  viewPdf: "Преглед на PDF",
  requiredConsentTitle: "Задължително съгласие",
  acceptAndContinue: "Приемане и продължаване",
};

export default {
  messages,
};
